import type { LanguageCode } from '@/config/languages'

/**
 * Detects the user's preferred language based on browser locale.
 * Returns 'tr' for Turkish locales, 'en' for all others.
 * 
 * @returns {LanguageCode} 'tr' if browser locale indicates Turkey, 'en' otherwise
 */
export function detectLanguageFromBrowser(): LanguageCode {
  // Handle SSR or environments without navigator
  if (typeof window === 'undefined' || !navigator) {
    return 'en'
  }

  // Try to get the primary language from navigator
  const browserLocale = navigator.language || navigator.languages?.[0] || 'en'

  // Check if the locale starts with 'tr' (Turkish)
  // This covers: tr, tr-TR, tr-CY, etc.
  if (browserLocale.toLowerCase().startsWith('tr')) {
    return 'tr'
  }

  // Default to English for all other locales
  return 'en'
}

